export const ERROR_TYPE = {
  USER_FORBIDDEN: 'user forbidden',
  MAINTENANCE: 'maintenance',
} as const

export type ErrorType = (typeof ERROR_TYPE)[keyof typeof ERROR_TYPE]

export class ApiError extends Error {
  start: unknown
  end: unknown
  type: string

  constructor(msg: string, type: string, start: unknown, end: unknown) {
    super(msg)
    this.start = start
    this.end = end
    this.type = type
  }

  /**
   * Check if it is a MaintenanceError
   */
  static isMaintenanceError(err: unknown): boolean {
    if (err == null) return false
    return (err as ApiError).type === ERROR_TYPE.MAINTENANCE
  }

  /**
   * Check if it is a Forbidden
   */
  static isForbidden(err: unknown): boolean {
    if (err == null) return false
    return (err as ApiError).type === ERROR_TYPE.USER_FORBIDDEN
  }
}
